module.exports = __webpack_public_path__ + "images/56bbc3390c3917442f677bdeb616cd0b.jpg";